import React from 'react';
import styled from 'styled-components'
import { Helmet } from 'react-helmet';
import Loader from '../../Components/Loader';
import NormalText from '../../Components/NormalText';
import { media } from '../../styles/Mixin';
import CategoryBox from '../../Components/CategoryBox';
import CommentBox from '../../Components/CommentBox';
import UpdateCategoryWindow from '../../Components/NewWindow/UpdateCategoryWindow';


export default({
    ctgData,
    ctgLoading,
    cuData,
    cuLoading,
    tcData,
    tcLoading,
    ctgUpdateWindow,
    setCtgUpdateWindow,
    deleteClick,
    ctgUpdateState,
    setCtgUpdateState
})=>{
    if (ctgLoading || cuLoading || tcLoading){
        return(
            <>
                <Helmet>
                    <title>로딩중..</title>
                </Helmet>
                <Loader />
            </>
        )
    }else if(ctgData.seeCategory === null || cuData.seeUser === null){
        return(
            <Wrapper>
                <Helmet>
                    <title>존재하지 않는 채널</title>
                </Helmet>
                <NoExist>
                    <NormalText text={"채널이 존재하지 않습니다 😅"} />
                </NoExist>
            </Wrapper>
        )
    }else{
        return(
            <Wrapper>
                <Helmet>
                    <title>미정</title>
                </Helmet>
                <BigBox>
                    <CategoryBox
                        onClick={()=>{
                            // isSelf 아닐경우 카테고리는 클릭안되고 댓글은 가능하다 내 댓글에 저장할 수 있는거니까? 
                            if(cuData.seeUser.isSelf){
                                setCtgUpdateWindow(true)
                            }
                        }}
                        isSelf={cuData.seeUser.isSelf}
                        categoryName={ctgUpdateState === true ? "변경중..👈" : ctgData.seeCategory.categoryName} 
                        categoryCount={ctgData.seeCategory.categoryCount}
                    />
                    <ContentBox>
                        {
                            tcData.seeTopComment.map((comment,i)=>(
                                <CommentBox 
                                    key={i}
                                    topProfileImage={comment.makerChannelProfileImageUrl}
                                    topAuthorName={comment.makerChannelDisplayName}
                                    topCommentText={comment.textOriginal}
                                    replyCount={comment.reComment.length}
                                    reComments={comment.reComment}
                                    comment={comment}
                                />
                            ))
                        }
                    </ContentBox>
                </BigBox>
                {
                    ctgUpdateWindow && 
                    (
                        <UpdateCategoryWindow
                            categoryName = {ctgData.seeCategory.categoryName}
                            setCtgUpdateWindow={setCtgUpdateWindow}
                            deleteClick={deleteClick}
                            setCtgUpdateState={setCtgUpdateState}
                            categoryId={ctgData.seeCategory.id}
                        />
                    )
                }
            </Wrapper>
        )

    }
}


const Wrapper = styled.div`
    display:flex;
    justify-content:center;
    align-items:center;
    /* min-height:50vh; */
    width:100%;
`

const NoExist = styled.div`
    display:flex;
    justify-content:center;
    align-items:center;
`

const BigBox = styled.div`
    display:flex;
    flex-direction:column;
    align-items:center;
    width:100%;
    /* background-color:red; */
`

const ContentBox = styled.div`
  display:flex;
  flex-direction:column;
  align-items:center;
  padding: 0px 10px 0px 10px;
  /* width:100%; */
  ${media.deskTop`max-width:32%;`}
  ${media.mobile`max-width:70%;`}
  margin-top:20px;
`


